// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MoreDetailsModal_title__hK9Le {
  font-size: 24px;
  font-weight: 600;
  font-style: normal;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  color: #FFFFFF;
  padding: 16px;
  text-align: center;
}
.MoreDetailsModal_title__hK9Le .MoreDetailsModal_titleText__6EmP7 {
  width: 90%;
  margin: 0 auto;
}

.MoreDetailsModal_wrapper__rujPU {
  padding: 16px;
}

.MoreDetailsModal_message__YHnc\\+ {
  color: #DAD6CE;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 24px;
}

.MoreDetailsModal_buttons__2a\\+od {
  display: flex;
  justify-content: end;
  gap: 16px;
}

.MoreDetailsModal_modalImage__9LHyT {
  width: 84px;
  height: 84px;
}

.MoreDetailsModal_modalContent__PWIMB {
  background: #222121;
  border-radius: 12px;
  max-width: 540px;
  width: 90%;
  max-height: 80%;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.MoreDetailsModal_modalContent_top_button__fgun7 {
  padding: 16px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  display: flex;
  justify-content: center;
  align-items: center;
}
.MoreDetailsModal_modalContent_top_button__fgun7 .MoreDetailsModal_modalContent_top_button_header__sVAjG {
  margin: auto;
  text-align: center;
  color: #faf9f8;
  font-size: 24px;
  font-family: "Open Sans SemiBold";
}
.MoreDetailsModal_modalContent_top_button__fgun7 .MoreDetailsModal_modalContent_top_button_x__mvrW- {
  cursor: pointer;
}

.MoreDetailsModal_modal_inner__Ozsqr {
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  gap: 6px;
}
.MoreDetailsModal_modal_inner__Ozsqr .MoreDetailsModal_modal_inner_price__kCLt5 {
  border-radius: 100px;
  background: rgba(255, 255, 255, 0.1);
}
.MoreDetailsModal_modal_inner__Ozsqr .MoreDetailsModal_modal_inner_price__kCLt5 .MoreDetailsModal_modal_inner_price_p__wyedl {
  font-family: "Open Sans SemiBold";
  display: flex;
  justify-content: center;
  font-weight: 400;
  font-size: 14px;
  color: #fff;
  width: auto;
  height: auto;
  padding: 6px 8px;
}
.MoreDetailsModal_modal_inner__Ozsqr .MoreDetailsModal_modal_inner_name__-Ohor .MoreDetailsModal_modal_inner_name_n__U2GnV {
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  color: #ffffff;
}
.MoreDetailsModal_modal_inner__Ozsqr .MoreDetailsModal_modal_inner_desc__rY0BT .MoreDetailsModal_modal_inner_desc_d__Q7Z1Y {
  font-family: "Open Sans Regular";
  font-size: 14px;
  color: #c2bdb2;
  line-height: 1.5em;
}

.MoreDetailsModal_modal_inner_buttons__O3MHw {
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: end;
  align-items: center;
}
.MoreDetailsModal_modal_inner_buttons__O3MHw .MoreDetailsModal_modal_inner_buttons_take__EnSvT {
  background: #f2f740;
  border-radius: 12px;
  width: 73px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.MoreDetailsModal_modal_inner_buttons__O3MHw .MoreDetailsModal_modal_inner_buttons_take__EnSvT .MoreDetailsModal_modal_inner_buttons_take_t__gdVu\\+ {
  font-family: "Open Sans SemiBold";
  font-size: 14px;
  color: #292621;
  cursor: pointer;
}
.MoreDetailsModal_modal_inner_buttons__O3MHw .MoreDetailsModal_modal_inner_buttons_take__EnSvT .MoreDetailsModal_modal_inner_buttons_take_t__gdVu\\+ .MoreDetailsModal_btn__RGqiU {
  cursor: pointer;
}
.MoreDetailsModal_modal_inner_buttons__O3MHw .MoreDetailsModal_rounded__Dfyb\\+ {
  border-radius: 100px 100px 100px 100px;
}

.MoreDetailsModal_modal_inner_buttons_cancel__7hj19 {
  display: flex;
  justify-content: end;
}
.MoreDetailsModal_modal_inner_buttons_cancel__7hj19 .MoreDetailsModal_modal_inner_buttons_cancel_c__K6Opw {
  display: flex;
  justify-content: end;
  cursor: pointer;
}

.MoreDetailsModal_closeBtn__jL8XF {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/modals/more-details-modal/MoreDetailsModal.module.scss","webpack://./src/assets/styles/_fonts.scss"],"names":[],"mappings":"AAEA;ECqIE,eAAA;EACA,gBAAA;EACA,kBAAA;EDpIA,iDAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;AAAF;AAEE;EACE,UAAA;EACA,cAAA;AAAJ;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,oBAAA;EACA,SAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAGA;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;AAAF;;AAEA;EACE,kBAAA;EACA,kDAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;AAAE;EACE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,iCAAA;AAEJ;AAAE;EACE,eAAA;AAEJ;;AACA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,QAAA;AAEF;AADE;EACE,oBAAA;EACA,oCAAA;AAGJ;AAFI;EACE,iCAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAIN;AAAI;ECgFF,eAAA;EACA,gBAAA;EACA,kBAAA;EDhFI,gBAAA;EACA,eAAA;EACA,cAAA;AAIN;AAAI;EACE,gCAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AAEN;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;EACA,mBAAA;AACF;AACE;EACE,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AACJ;AAAI;EACE,iCAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAEN;AAAM;EACE,eAAA;AAER;AAKE;EACE,sCAAA;AAHJ;;AAUA;EACE,aAAA;EACA,oBAAA;AAPF;AAQE;EACE,aAAA;EACA,oBAAA;EACA,eAAA;AANJ;;AAUA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AAPF","sourcesContent":["@use 'assets/styles/global.scss' as *;\n\n.title {\n  @include subtitle1;\n\n  border-bottom: 1px solid $light-10;\n  color: #FFFFFF;\n  padding: 16px;\n  text-align: center;\n\n  .titleText {\n    width: 90%;\n    margin: 0 auto;\n  }\n}\n\n.wrapper {\n  padding: 16px;\n}\n\n.message {\n  color: #DAD6CE;\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 24px;\n}\n\n.buttons {\n  display: flex;\n  justify-content: end;\n  gap: 16px;\n}\n\n.modalImage {\n  width: 84px;\n  height: 84px;\n}\n.modalContent {\n  background: #222121;\n  border-radius: 12px;\n  max-width: 540px;\n  width: 90%;\n  max-height: 80%;\n  overflow-y: auto;\n  position: relative;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n}\n.modalContent_top_button {\n  padding: 16px 16px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  .modalContent_top_button_header {\n    margin: auto;\n    text-align: center;\n    color: #faf9f8;\n    font-size: 24px;\n    font-family: \"Open Sans SemiBold\";\n  }\n  .modalContent_top_button_x {\n    cursor: pointer;\n  }\n}\n.modal_inner {\n  display: flex;\n  flex-direction: column;\n  margin-top: 12px;\n  gap: 6px;\n  .modal_inner_price {\n    border-radius: 100px;\n    background: rgba(255, 255, 255, 0.1);\n    .modal_inner_price_p {\n      font-family: \"Open Sans SemiBold\";\n      display: flex;\n      justify-content: center;\n      font-weight: 400;\n      font-size: 14px;\n      color: #fff;\n      width: auto;\n      height: auto;\n      padding: 6px 8px;\n    }\n  }\n  .modal_inner_name {\n    .modal_inner_name_n {\n      @include body2;\n      font-weight: 700;\n      font-size: 20px;\n      color: #ffffff;\n    }\n  }\n  .modal_inner_desc {\n    .modal_inner_desc_d {\n      font-family: \"Open Sans Regular\";\n      font-size: 14px;\n      color: #c2bdb2;\n      line-height: 1.5em;\n    }\n  }\n}\n.modal_inner_buttons {\n  margin-top: 16px;\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  justify-content: end;\n  align-items: center;\n\n  .modal_inner_buttons_take {\n    background: #f2f740;\n    border-radius: 12px;\n    width: 73px;\n    height: 38px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    .modal_inner_buttons_take_t {\n      font-family: \"Open Sans SemiBold\";\n      font-size: 14px;\n      color: #292621;\n      cursor: pointer;\n\n      .btn {\n        cursor: pointer;\n      }\n    }\n\n    \n  }\n\n  .rounded {\n    border-radius: 100px 100px 100px 100px; \n  }\n\n  \n}\n\n\n.modal_inner_buttons_cancel {\n  display: flex;\n  justify-content: end;\n  .modal_inner_buttons_cancel_c {\n    display: flex;\n    justify-content: end;\n    cursor: pointer;\n  }\n}\n\n.closeBtn {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n}\n\n@media (max-width: 1024px) {}","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n// New fonts\n\n@mixin header1 {\n  font-size: 56px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header3 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header4 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header5 {\n  font-size: 28px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1 {\n  font-size: 24px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle2 {\n  font-size: 20px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle3 {\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle4 {\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonLarge {\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin buttonMedium {\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin buttonSmall {\n  font-size: 13px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `MoreDetailsModal_title__hK9Le`,
	"titleText": `MoreDetailsModal_titleText__6EmP7`,
	"wrapper": `MoreDetailsModal_wrapper__rujPU`,
	"message": `MoreDetailsModal_message__YHnc+`,
	"buttons": `MoreDetailsModal_buttons__2a+od`,
	"modalImage": `MoreDetailsModal_modalImage__9LHyT`,
	"modalContent": `MoreDetailsModal_modalContent__PWIMB`,
	"modalContent_top_button": `MoreDetailsModal_modalContent_top_button__fgun7`,
	"modalContent_top_button_header": `MoreDetailsModal_modalContent_top_button_header__sVAjG`,
	"modalContent_top_button_x": `MoreDetailsModal_modalContent_top_button_x__mvrW-`,
	"modal_inner": `MoreDetailsModal_modal_inner__Ozsqr`,
	"modal_inner_price": `MoreDetailsModal_modal_inner_price__kCLt5`,
	"modal_inner_price_p": `MoreDetailsModal_modal_inner_price_p__wyedl`,
	"modal_inner_name": `MoreDetailsModal_modal_inner_name__-Ohor`,
	"modal_inner_name_n": `MoreDetailsModal_modal_inner_name_n__U2GnV`,
	"modal_inner_desc": `MoreDetailsModal_modal_inner_desc__rY0BT`,
	"modal_inner_desc_d": `MoreDetailsModal_modal_inner_desc_d__Q7Z1Y`,
	"modal_inner_buttons": `MoreDetailsModal_modal_inner_buttons__O3MHw`,
	"modal_inner_buttons_take": `MoreDetailsModal_modal_inner_buttons_take__EnSvT`,
	"modal_inner_buttons_take_t": `MoreDetailsModal_modal_inner_buttons_take_t__gdVu+`,
	"btn": `MoreDetailsModal_btn__RGqiU`,
	"rounded": `MoreDetailsModal_rounded__Dfyb+`,
	"modal_inner_buttons_cancel": `MoreDetailsModal_modal_inner_buttons_cancel__7hj19`,
	"modal_inner_buttons_cancel_c": `MoreDetailsModal_modal_inner_buttons_cancel_c__K6Opw`,
	"closeBtn": `MoreDetailsModal_closeBtn__jL8XF`
};
export default ___CSS_LOADER_EXPORT___;
